import { CSSProperties } from 'react';

export type Icons =
  | 'icon-account'
  | 'icon-arrow'
  | 'icon-bag'
  | 'icon-back'
  | 'icon-bucket'
  | 'icon-call'
  | 'icon-cart'
  | 'icon-chart'
  | 'icon-close'
  | 'icon-dashboard'
  | 'icon-delivery'
  | 'icon-edit'
  | 'icon-envelope'
  | 'icon-eye'
  | 'icon-eye-closed'
  | 'icon-filter'
  | 'icon-finance'
  | 'icon-invoice'
  | 'icon-phone'
  | 'icon-pin'
  | 'icon-print'
  | 'icon-promo'
  | 'icon-quote'
  | 'icon-search'
  | 'icon-trash'
  | 'icon-user'
  | 'icon-user-protection';

type IconProps = {
  className?: string;
  color?: string;
  fill?: string;
  height?: number;
  id: Icons;
  stroke?: string;
  style?: CSSProperties;
  width?: number;
};

function Icon(props: IconProps) {
  const { className, fill = 'none', height = 16, id, width = 16, ...rest } = props;

  return (
    <svg fill={fill} height={height} width={width} {...rest}>
      <use xlinkHref={`#${id}`} />
    </svg>
  );
}

export default Icon;
